<template>
    <div class="form-group">
        <kendo-dropdown
            :value="id"
            @input="input => id = input.value"
            :label="i18n('Common.Dealer')"
            :index="1"
            :dataSource="storesDataSource">
        </kendo-dropdown>
        <kendo-datepicker
            name="periodDate"
            v-model="periodDate"
            depth="year"
            format="M/yyyy"
            :placeholder="i18n('Common.ReferenceDate')">
        </kendo-datepicker>
    </div>
</template>

<script>
import _ from 'lodash';

import { i18nMixin, momentMixin } from '../../../shared/mixins';
import { loading, unloading, notify, NOTIFY_TYPE } from '../../../../scripts/shared';
import environment from '../../../../scripts/environment';

import KendoDropdown from '../../../shared/components/kendo-dropdown/kendo-dropdown.component';
import KendoDatepicker from '../../../shared/components/kendo-datepicker/kendo-datepicker.component';
import { RetentionSpreadsheet } from '../../../../spreadsheets/retention-spreadsheet';

export default {
    name: 'download-customers-retention',

    props: {},

    computed: {},

    data () {
        let stores = environment.get('CONFIG.FILTERS.DEALERS_STORES');
        stores = _.size(environment.get('CONFIG.FILTERS.CUSTOMERS_STORES')) ? _.filter(stores, s => _.some(environment.get('CONFIG.FILTERS.CUSTOMERS_STORES'), cs => String(cs) === String(s.IdLojaCliente))) : stores;
        const storesDataSource = _(stores)
            .map(s => ({
                text: s.Nome,
                value: s.IdLojaCliente
            }))
            .orderBy(s => s.text)
            .value();

        return {
            id: storesDataSource[0].value,
            periodDate: this.moment().startOf('month').subtract(1, 'month').toDate(),
            storesDataSource
        };
    },

    watch: {},

    mixins: [i18nMixin, momentMixin],

    methods: {
        saveAsExcel () {
            loading();

            this.$http.get(`${environment.get('API_HOST')}/lojaconcessionaria/getClients?IdLoja=${this.id}&AnoMesInicio=${this.moment(this.periodDate).format('YYYYMM')}&AnoMesFim=${this.moment(this.periodDate).endOf('month').add(3, 'months').format('YYYYMM')}`)
                .then((res) => {
                    if (!_.size(res.body)) {
                        notify(NOTIFY_TYPE.LOG, 'Sem dados de retenção para a loja selecionada.');
                        return unloading(true);
                    }

                    const dataSource = _.map(res.body.objects.output.geometries, f => f.properties);
                    (new RetentionSpreadsheet()).mount(dataSource).create().saveAsExcel();
                    unloading(true);
                })
                .catch((err) => {
                    console.log(err);
                    return unloading(true);
                });
        }
    },

    mounted () {},

    destroyed () {},

    components: {
        KendoDatepicker,
        KendoDropdown
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/download/components/download-customers-retention/download-customers-retention.component.vue